import { Pipe, PipeTransform } from '@angular/core';
import { PortalTypeEnum } from '@ats/api/cm';
import { cmBooleanPipeLocalizationDefaults } from '../models';
import { CmSettingsService } from '../services';
import { CmLocalizationService } from '../services/localization.service';

@Pipe({
    name: 'cmBool',
    standalone: false
})
export class CmBooleanPipe implements PipeTransform {
	private readonly localization: { positive: string; negative: string; indeterminate: string };

	constructor(
		private readonly localizationService: CmLocalizationService,
		private readonly settings: CmSettingsService
	) {
		this.localization = this.getLocalizations();
	}

	transform(value?: boolean | string, binary = true): string {
		if (binary || value !== null) {
			if (!value || value === '' || value === '0') {
				return this.localization.negative;
			} else {
				return this.localization.positive;
			}
		} else {
			return this.localization.indeterminate;
		}
	}

	private getLocalizations() {
		const feature = this.settings.portal === PortalTypeEnum.CandidatePortal ? 'CandidateAccess' : 'Core';
		const { POSITIVE, NEGATIVE, INDETERMINATE } = cmBooleanPipeLocalizationDefaults(feature);

		const positive = (this.localizationService.findLocalization(POSITIVE.key) || {}).value || POSITIVE.defaultValue;
		const negative = (this.localizationService.findLocalization(NEGATIVE.key) || {}).value || NEGATIVE.defaultValue;
		const indeterminate =
			(this.localizationService.findLocalization(INDETERMINATE.key) || {}).value || INDETERMINATE.defaultValue;

		return {
			positive,
			negative,
			indeterminate,
		};
	}

	public isTrue(val: boolean | string) {
		return !this.isFalsey(val);
	}

	public isTruthy(val: boolean | string) {
		return this.isTrue(val);
	}

	public isFalse(val: boolean | string) {
		return (
			val === false ||
			val === '' ||
			val.toString().toLowerCase() === this.localization.negative.toLowerCase() ||
			val.toString().toLowerCase() === 'false'
		);
	}

	public isNull(val: boolean | string) {
		return val === null || val === this.localization.indeterminate;
	}

	public isFalsey(val: boolean | string) {
		return this.isFalse(val) || this.isNull(val);
	}
}
